module.exports = function(data) {
var __t, __p = '';
__p += '<li role="presentation" class="queryable-list-element">\n    <a href="#" data-index="' +
((__t = ( data.i )) == null ? '' : __t) +
'" data-filter="' +
((__t = ( data.value )) == null ? '' : __t) +
'" class="filterOption ' +
((__t = ( ((data.active) === true) ? 'active' : '')) == null ? '' : __t) +
'">\n        <i class="far fa-check check-icon"></i> ' +
((__t = ( data.name )) == null ? '' : __t) +
'\n    </a>\n</li>\n';
return __p
}